module.exports = __webpack_public_path__ + "static/media/valor2.906c9f96.png";